// src/pages/Home.jsx
import React from "react";
import HeroCarousel from "../components/Home/HeroCarousel";
import AboutSection from "../components/Home/AboutSection";
import WhyChooseUs from "../components/Home/WhyChooseUs";
import ServicesGrid from "../components/Home/ServicesGrid";
import Industries from "../components/Home/Industries";
import Clients from "../components/Home/Clients";

const Home = () => {
  return (
    <div className="home-page">
      {/* Hero Carousel Section */}
      <HeroCarousel />

      {/* About Us Section */}
      <AboutSection />

      {/* Why Choose Us Section */}
      <WhyChooseUs />

      {/* Services Grid Section */}
      <ServicesGrid />

      {/* Industries We Serve Section */}
      <Industries />

      {/* Clients Section */}
      <Clients />
    </div>
  );
};

export default Home;
